/**
 * convert snake_case to camelCase
 *
 * @param str - The string to convert.
 * @returns The camelCase string.
 */
export const snakeToCamel = str => str.toLowerCase() // Make all lowercase
.replace(/(^_+)|(_+$)/g, '') // Remove leading and trailing underscores
.replace(/_+([^_])/g, (_, match) => match.toUpperCase()); // Remove underscores and capitalize next letter

export const camelToKebab = str => str.replace(/[A-Z]+(?![^A-Z])|[A-Z]/g, (a, b) => (b ? '-' : '') + a.toLowerCase());
//# sourceMappingURL=strings.js.map